import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

class Console extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <Paper>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>Number of Tenants</TableCell>
                <TableCell>{this.props.app.projects.length}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Total number of experience configured</TableCell>
                <TableCell>xxxx</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Total number of users</TableCell>
                <TableCell>xxxx</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(Console)));



// WEBPACK FOOTER //
// ./src/sub-projects/console/containers/content.tsx